import { Button } from '@timelyapp/react';
import { Clock } from 'components/Icons';
import SplashMessage from 'components/SplashMessage';
import { Table, Tbody, Th, Tr } from 'components/ui-blocks/table';
import React, { Component } from 'react';
import { ActivityFilterType } from 'redux/modules/activities.types';
import type { Activity } from 'types/activity';
import styles from './ActivitiesTable.module.scss';
import ActivitiesTableRow from './ActivitiesTableRow';

interface Props {
  activities: Array<Activity>;
  className?: string | undefined;
  filteredBy?: ActivityFilterType;
  showContextColumn?: boolean | null | undefined;
  router?: any;
  onLoadMore: () => void;
  hasMore?: boolean | null | undefined;
  isLoading?: boolean;
}

export default class ActivitiesTable extends Component<Props> {
  static defaultProps = {
    activities: [],
    showContextColumn: true,
  };
  handleLoadMore = () => {
    this.props.onLoadMore();
  };

  getActivitiesGrouped(activities: Array<Activity>): Array<{
    label: string;
    activities: Array<Activity>;
  }> {
    const groups: Array<{
      label: string;
      activities: Array<Activity>;
    }> = [];

    activities.forEach(a => {
      let group = groups.find(g => g.label === a.relativeDay);
      if (group == null) {
        group = { label: a.relativeDay, activities: [] };
        groups.push(group);
      }
      group.activities.push(a);
    });

    return groups;
  }

  render() {
    const {
      activities,
      hasMore,
      isLoading,
      onLoadMore,
      router,
      showContextColumn,
      filteredBy = ActivityFilterType.All,
      ...rest
    } = this.props;

    if (!isLoading && !activities.length) {
      return (
        <SplashMessage>
          <Clock />
          <h2>No activities found</h2>
          {filteredBy !== ActivityFilterType.All && (
            <p>Expand your search by adjusting the filters</p>
          )}
        </SplashMessage>
      );
    }

    return (
      <>
        <Table {...rest}>
          <Tbody>
            {this.getActivitiesGrouped(activities).map(group => (
              <React.Fragment key={group.label}>
                <Tr>
                  <Th className={styles.label} colSpan={5}>
                    <span>{group.label}</span>
                  </Th>
                </Tr>
                {group.activities.map(activity => {
                  return (
                    <ActivitiesTableRow
                      key={activity.id}
                      showContextColumn={showContextColumn}
                      activity={activity}
                    />
                  );
                })}
              </React.Fragment>
            ))}
          </Tbody>
        </Table>
        {hasMore && (
          <div className={styles.loadMore}>
            <Button onClick={this.handleLoadMore} isLoading={isLoading}>
              Load more
            </Button>
          </div>
        )}
      </>
    );
  }
}
